import {
  AfterViewInit,
  Component,
  inject,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {SwiperComponent, SwiperModule} from 'swiper/angular';
import {PostModel} from '../../models/post.model';
import {UserModel} from '../../models/user.model';
import SwiperCore, {Navigation, SwiperOptions} from 'swiper';
import {AuthService} from '../../services/auth/auth.service';
import {PostService} from '../../services/post/post.service';
import {GlobalService} from '../../services/global/global.service';
import {Router} from '@angular/router';
import {AlertController, IonicModule, ModalController, NavController, PopoverController} from '@ionic/angular';
import {FeedService} from '../../services/feed/feed.service';
import {StorageService} from '../../services/storage/storage.service';
import {ApiResponse} from '../../services/utils';
import {NativeAudio} from '@capgo/native-audio';
import {StatusBar} from "@capacitor/status-bar";
import {ActionPointDetailModalComponent} from "../action-point-detail-modal/action-point-detail-modal.component";
import {firstValueFrom, Observable} from "rxjs";
import {MapService} from "../../services/impact-map/impact-map.service";
import {MapModalReturn} from "../../models/map.models";
import {NavigationService} from "../../services/navigations/navigation.service";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ViewPostPageRoutingModule} from "../../pages/home/view-post/view-post-routing.module";
import {ReadMoreModule} from "../../components/read-more/read-more.module";
import {HeaderModule} from "../../components/header/header.module";
import {InteractedPeopleModule} from "../../components/interacted-people/interacted-people.module";
import {SetRatingModule} from "../../components/set-rating/set-rating.module";
import {CommentsModule} from "../../components/comments/comments.module";
import {TagUserModule} from "../../components/tag-user/tag-user.module";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {
  MomentSelectedActionPointComponent
} from "../moment-selected-action-point/moment-selected-action-point.component";
import {ApAssignMomentModalComponent} from "../ap-assign-moment-modal/ap-assign-moment-modal.component";

SwiperCore.use([Navigation]);

@Component({
  selector: 'app-gallery-modal',
  templateUrl: './gallery-modal.component.html',
  styleUrls: ['./gallery-modal.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ViewPostPageRoutingModule,
    ReactiveFormsModule,
    ReadMoreModule,
    HeaderModule,
    InteractedPeopleModule,
    SetRatingModule,
    CommentsModule,
    TagUserModule,
    SwiperModule,
    TranslatePipe,
  ],
  standalone: true
})
export class GalleryModalComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('swiper', {static: false}) swiper?: SwiperComponent;
  @Input() momentId: string = '';
  @Input() actionPointId: string = '';
  @Input() actionPointFeed?: boolean;
  @Input() singleMode: boolean = false;


  selectedMoment: string;
  selectedMomentActionPoint: string;

  private actionPointModal?: HTMLIonModalElement;

  isLoadingGallery: boolean = false;
  isWeb: boolean = false;
  isMobile: boolean = false;

  moments: PostModel[] = [];
  errorMessage = [];

  user: UserModel;
  item: PostModel;

  private modalOpen = {
    ap: false
  }

  swiperConfig: SwiperOptions = {
    speed: 400,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };


  currentPages: Set<number> = new Set();
  lastPageReached = false;
  firstPageReached = false;

  private translate: TranslateService = inject(TranslateService);
  private alertController: AlertController = inject(AlertController);
  private auth: AuthService = inject(AuthService);
  private postService: PostService = inject(PostService);
  private globalService: GlobalService = inject(GlobalService);
  private router: Router = inject(Router);
  private navController: NavController = inject(NavController);
  private feedService: FeedService = inject(FeedService);
  private popoverCtrl: PopoverController = inject(PopoverController);
  private storage: StorageService = inject(StorageService);
  private modalController: ModalController = inject(ModalController);
  private zone: NgZone = inject(NgZone);
  private mapService: MapService = inject(MapService);
  private navigationService: NavigationService = inject(NavigationService);

  constructor() {
    this.user = this.auth.user;
    this.auth.getUserStatus.subscribe(() => {
      this.user = this.auth.user;
    });
  }

  ngOnInit() {
    this.isWeb = this.globalService.isWeb;
    this.isMobile = this.globalService.isMobile();
    this.selectedMoment = this.momentId;
    this.selectedMomentActionPoint = this.actionPointId;

    if (!this.isWeb) {
      StatusBar.hide();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.globalService.isMobile()) {
      if (changes['momentId'] || changes['actionPointId']) {
        this.selectedMoment = this.momentId;
        this.selectedMomentActionPoint = this.actionPointId;
        this.loadPagedWindow();
      }
    }
  }

  ngAfterViewInit() {
    this.loadPagedWindow();
  }

  async loadPagedWindow() {
    this.isLoadingGallery = true;

    const res: ApiResponse = await firstValueFrom(this.feedService.apiGetPageForMoment(this.selectedMoment ?? '', this.selectedMomentActionPoint ?? ''));
    const currentPage: number = res?.data?.[0]?.page ? res.data[0].page : 0;
    this.currentPages = new Set([currentPage]);

    const pagesToLoad: number[] = [currentPage - 1, currentPage, currentPage + 1].filter((page: number): boolean => page >= 1);

    let shouldFilterByActionPoint: boolean = false;
    let haveMomentId: boolean = false
    if (this.selectedMomentActionPoint) {
      shouldFilterByActionPoint = true
    }

    if (this.selectedMoment) {
      haveMomentId = true
    }

    const requests: Observable<ApiResponse>[] = pagesToLoad.map(p => {
        if (this.actionPointFeed) {
          return this.feedService.apiGetActionPointFeedGallery(
            haveMomentId ? this.selectedMoment : null,
            shouldFilterByActionPoint ? this.selectedMomentActionPoint : null,
            p
          )
        } else {
          return this.feedService.apiGetMomentsGallery(this.selectedMoment)
        }
      }
    );

    Promise.all(requests.map((req: Observable<ApiResponse>) => req.toPromise())).then((results: ApiResponse[]) => {
      const allMoments = results.flatMap(r => (r?.status ? r.data : []));

      const uniqueMoments = allMoments.filter((m, index, self) =>
        index === self.findIndex(t => t.id === m.id)
      );

      this.zone.run(() => {
        this.moments = uniqueMoments;
        this.isLoadingGallery = false;

        requestAnimationFrame(() => {
          const index = this.moments.findIndex(m => m.id === parseInt(this.selectedMoment, 10));
          if (this.swiper?.swiperRef) {
            this.swiper.swiperRef.updateSlides();
            this.swiper.swiperRef.update();
            this.swiper.swiperRef.updateSize();
            this.swiper.swiperRef.slideTo(index >= 0 ? index : 0, 0, false);
          }
        });
      });
    });
  }


  onSlideChange() {
    if (!this.swiper?.swiperRef) return;

    const swiper = this.swiper.swiperRef;
    const activeIndex = swiper.activeIndex;
    const currentMoment = this.moments[activeIndex];
    const selectedMomentId = currentMoment?.id?.toString();
    const selectedPage = currentMoment?.page;

    this.selectedMoment = selectedMomentId;

    if (!selectedPage || this.isLoadingGallery) return;

    const maxPagesToKeep = 5;
    const pagesToRemove = Array.from(this.currentPages).filter(p => Math.abs(p - selectedPage) > 1);

    if (this.currentPages.size > maxPagesToKeep) {
      const currentMomentIdBeforeRemove = this.moments[activeIndex]?.id;

      this.moments = this.moments.filter(m => !pagesToRemove.includes(m.page));
      pagesToRemove.forEach(p => this.currentPages.delete(p));

      this.zone.run(() => {
        const newIndex = this.moments.findIndex(m => m.id === currentMomentIdBeforeRemove);
        setTimeout(() => this.forceSwiperUpdateAndSlideTo(newIndex >= 0 ? newIndex : 0), 0);
      });
    }

    // load next Page
    if (!this.currentPages.has(selectedPage + 1) && !this.lastPageReached) {
      if (this.actionPointFeed) {
        this.feedService.apiGetActionPointFeedGallery(null, this.selectedMomentActionPoint, selectedPage + 1).subscribe((res: ApiResponse) => {
          if (res?.status && res.data.length > 0) {
            const newMoments = res.data.filter(m => !this.moments.some(existing => existing.id === m.id));
            this.moments.push(...newMoments);
            this.currentPages.add(selectedPage + 1);
            this.zone.run(() => {
              setTimeout(() => this.forceSwiperUpdate(), 0);
            });
          } else {
            this.lastPageReached = true;
          }
        });
      } else {
        this.feedService.apiGetMomentsGallery(this.selectedMoment, selectedPage + 1).subscribe((res: ApiResponse) => {
          if (res?.status && res.data.length > 0) {
            const newMoments = res.data.filter(m => !this.moments.some(existing => existing.id === m.id));
            this.moments.push(...newMoments);
            this.currentPages.add(selectedPage + 1);
            this.zone.run(() => {
              setTimeout(() => this.forceSwiperUpdate(), 0);
            });
          } else {
            this.lastPageReached = true;
          }
        });
      }
    }

    // load previous Page
    if (selectedPage > 1 && !this.currentPages.has(selectedPage - 1) && !this.firstPageReached) {
      if (this.actionPointFeed) {
        this.feedService.apiGetActionPointFeedGallery(null, this.selectedMomentActionPoint, selectedPage - 1).subscribe(res => {
          if (res?.status && res.data.length > 0) {
            const newMoments = res.data.filter(m => !this.moments.some(existing => existing.id === m.id));

            const currentMomentId = this.selectedMoment;
            this.moments.unshift(...newMoments);
            this.currentPages.add(selectedPage - 1);
            this.zone.run(() => {
              const newIndex = this.moments.findIndex(m => m.id === parseInt(currentMomentId, 10));
              setTimeout(() => this.forceSwiperUpdateAndSlideTo(newIndex), 0);
            });
          } else {
            this.firstPageReached = true;
          }
        });
      } else {
        this.feedService.apiGetMomentsGallery(this.selectedMoment, selectedPage - 1).subscribe((res: ApiResponse) => {
          if (res?.status && res.data.length > 0) {
            const newMoments = res.data.filter(m => !this.moments.some(existing => existing.id === m.id));
            this.moments.unshift(...newMoments);
            this.currentPages.add(selectedPage - 1);
            this.zone.run(() => {
              const newIndex = this.moments.findIndex(m => m.id === parseInt(this.selectedMoment, 10));
              setTimeout(() => this.forceSwiperUpdateAndSlideTo(newIndex), 0);
            });
          } else {
            this.firstPageReached = true;
          }
        });
      }

    }
  }

  setMood(moodId: number, postId: number, index: number) {
    if (this.auth && this.auth.isAuthenticated) {
      const actualMood = this.moments[index].hasMood;
      if (actualMood === 0) {
        this.moments[index].moodsCount += 1;
        this.moments[index].hasMood = moodId;
      } else {
        this.moments[index].hasMood = moodId;
      }

      const input = new FormData();
      input.append('postId', postId.toString());
      input.append('moodId', moodId.toString());

      this.postService.apiSetMood(input).subscribe(async (result: ApiResponse) => {
        if (result?.status && !this.isWeb && await this.storage.isInteractionSoundOn()) {
          NativeAudio.play({assetId: 'moment', time: 0});
        }
      });

      setTimeout(() => {
        this.popoverCtrl.dismiss();
      }, 1000);
    } else {
      this.globalService.openLoginModal();
    }
  }

  async openProfileOrCompany(id: number, type: string, moment: PostModel) {
    if (type === 'user') {
      await this.navController.navigateForward(['/app/home/other-profile/' + id]);
    } else {
      await this.navigationService.openCompanyProfileById(id, moment.createdBy.isAdmin);
      //await this.navController.navigateForward(['/app/team/company/view-company/7/' + id]);
    }
    await this.modalController.dismiss();
    if (!this.isWeb) {
      try {
        await StatusBar.show();
      } catch (err) {
        console.log('ERRPR')
      }

    }
  }

  back() {
    this.router.navigate(['/app/home/']);
    if (!this.isWeb) {
      StatusBar.show();
    }
  }

  getCreatedTime(createdTime: string) {
    return this.globalService.timeSince(createdTime);
  }

  getMoodOfMoment(moment: PostModel) {
    return moment.moods.find(mood => mood.id === moment.hasMood)?.iconSolid || '';
  }

  async openActionPoint(actionPointId: number) {
    if (this.router.url.includes('map-moment')) {
      await this.updateRoute(this.selectedMoment, actionPointId);
    }
    if (window.screen.width > 460 && this.isWeb) {
      this.actionPointModal = await this.modalController.create({
        component: ActionPointDetailModalComponent,
        backdropDismiss: true,
        mode: 'ios',
        id: 'action-point-desktop-modal',
        componentProps: {
          actionPointId: actionPointId,
        },
        cssClass: 'desktop-modal',
      });
      await this.actionPointModal.present();
    } else {
      this.actionPointModal = await this.modalController.create({
        component: ActionPointDetailModalComponent,
        backdropDismiss: true,
        mode: 'ios',
        id: 'action-point-detail-modal',
        componentProps: {
          actionPointId: actionPointId,
        },
        breakpoints: [0, 0.8, 1],
        initialBreakpoint: 0.8,
        handle: true,

      });
      if (!this.isWeb) {
        await StatusBar.show();
      }
      await this.actionPointModal.present();
    }
  }

  forceSwiperUpdate() {
    if (!this.swiper?.swiperRef) return;
    this.zone.run(() => {
      const swiper = this.swiper.swiperRef;
      swiper.updateSlides();
      swiper.updateSize();
      swiper.update();
    });
  }

  forceSwiperUpdateAndSlideTo(index: number) {
    this.zone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (!this.swiper?.swiperRef) return;

          const swiper = this.swiper.swiperRef;
          swiper.updateSlides();
          swiper.updateSize();
          swiper.update();

          if (index >= 0 && index < this.moments.length) {
            swiper.slideTo(index, 0, false);
          }
        }, 0);
      });
    });
  }

  closeGallery() {
    if (this.isMobile && this.router.url.includes('map-moment')) {
      this.navController.back();
    }
    this.modalController.dismiss();
    if (!this.isWeb) {
      StatusBar.show();
    }
  }

  async openMapModal(long: string, lat: string, id: number, editable: boolean, moment?: PostModel) {
    if (this.popoverCtrl && (await this.popoverCtrl.getTop())) {
      await this.popoverCtrl.dismiss();
    }

    const reload: MapModalReturn = await this.mapService.openMapModal(
      long,
      lat,
      editable,
      'moment',
      id,
      (moment.longitude === null || moment.longitude === '') &&
      (moment.latitude === null || moment.latitude === '')
    );
    if (reload && reload.reload) {
      await this.updateRoute(moment.id.toString(), moment.moment_action_point)
      await this.loadPagedWindow();
    }
    if (reload && reload.replaceUrl) {
      await this.updateRoute(moment.id.toString(), moment.moment_action_point)
    }
  }

  async updateRoute(newId: string, actionPointId: number): Promise<void> {
    const currentUrl: string = this.router.url.split('?')[0];
    const newUrl: string = currentUrl.replace(/\/\d+$/, `/${newId}`);
    await this.router.navigateByUrl(`${newUrl}?actionPointId=${actionPointId}`, {replaceUrl: true});
  }

  async deletePost(item: PostModel) {
    await this.popoverCtrl.dismiss();
    const alert: HTMLIonAlertElement = await this.alertController.create({
      cssClass: 'remove-action-point-alert',
      header: this.translate.instant('hdl_delete_post'),
      message: this.translate.instant('txt_delete_post'),
      buttons: [
        {
          text: this.translate.instant('lbl_no'),
          role: 'cancel',
          cssClass: 'cancel-button',
          id: 'cancel-button',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('lbl_yes'),
          id: 'confirm-button',
          cssClass: 'confirm-button',
          handler: () => {
            this.apiDeletePost(item);
          }
        }
      ]
    });

    await alert.present();
  }

  private async apiDeletePost(item: PostModel): Promise<void> {
    this.postService.apiDeletePost(item.id).subscribe(async (result: ApiResponse) => {
      if (result.status) {
        await this.globalService.presentToast(this.translate.instant('txt_post_delete_success'));
        await this.loadPagedWindow();
        this.mapService.notifyMarkersUpdated();
      } else {
        await this.globalService.presentToast(this.translate.instant('txt_post_delete_failure'));
      }
    });
  }


  public async openActionPointAssignModal(moment: PostModel): Promise<void> {
    if (this.popoverCtrl && (await this.popoverCtrl.getTop())) {
      await this.popoverCtrl.dismiss();
    }

    if (!this.modalOpen.ap) {
      this.modalOpen.ap = true;
      if (moment.moment_action_point) {
        const modal = await this.modalController.create({
          component: MomentSelectedActionPointComponent,
          backdropDismiss: true,
          id: 'small-modal',
          mode: 'ios',
          componentProps: {
            actionPointId: moment.moment_action_point
          }
        });

        await modal.present();

        const {role} = await modal.onWillDismiss();
        if (role === 'unassigned') {
          moment.moment_action_point = null;

          const dataToSend = {
            moment_id: moment.id,
            action_point_id: moment.moment_action_point
          };

          this.postService.apiAssignMomentToActionPoint(dataToSend).subscribe(
            response => {
            },
            error => console.error('Assignment failed:', error)
          );
        }
      } else {
        if (!this.actionPointModal || this.actionPointModal && !this.actionPointModal.isOpen) {
          const mobileConfig = {
            breakpoints: [0.1, 0.3, 0.8],
            backdropBreakpoint: 0.8,
            initialBreakpoint: 0.3,
            backdropDismiss: false,
          }

          const webConfig = {
            cssClass: 'modal-gallery',
            backdropDismiss: true
          }

          const additionalConfig = this.globalService.isWeb ? webConfig : mobileConfig;
          this.actionPointModal = await this.modalController.create({
            id: 'moment-select-ap-modal',
            component: ApAssignMomentModalComponent,
            componentProps: {
              type: moment.createdByType === 'company' ? 'organization' : 'user',
              id: moment.createdBy.id,
              clickable: true,
              momentCard: true
            },
            mode: 'ios',
            ...additionalConfig
          });

          await this.actionPointModal.present();
          this.actionPointModal.isOpen = true;

          this.actionPointModal.onWillDismiss().then((data) => {
            if (data.role === 'submit') {
              moment.moment_action_point = data.data;
              const dataToSend = {
                moment_id: moment.id,
                action_point_id: moment.moment_action_point
              };

              this.postService.apiAssignMomentToActionPoint(dataToSend).subscribe(
                response => {
                },
                error => console.error('Assignment failed:', error)
              );

            }
            this.actionPointModal.isOpen = false;
          });
        }
      }
      this.modalOpen.ap = false;
    }
  }
}
